import React, { useRef, useEffect } from 'react'
import ReactDom from 'react-dom'
import useWindowDimentions from './hooks/useWindowDimentions'


const ModalOverlay = (props) => {

  const adminModalRef = useRef()

  const {width, height} = useWindowDimentions()

  useEffect(()=>{
    document.addEventListener("mousedown", (event) => {
      if (adminModalRef == null || adminModalRef.current == null || !adminModalRef.current.contains(event.target)){
        props.setTrigger(false)
      }
    });
  })

  return (props.trigger) ? (
    <div className = "position-fixed rounded d-flex justify-content-center align-items-center"
        onClick={(e)=>e.stopPropagation()}
        style={{zIndex:200, backgroundColor:"rgba(0,0,0,.6)", width:width, height:height}} 
        ref = {adminModalRef}>
        {props.content}
    </div>
  ) : ""
}

const AdminModal = (props) => {
    
  return (
    <>
      {ReactDom.createPortal(
        <ModalOverlay
          content = {props.content}
          trigger = {props.trigger}
          setTrigger = {props.setTrigger}
        />,
        document.getElementById('overlay-root')
        )
      }
    </>
  )
}

export default AdminModal
